import "swiper/css";

import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BsStarFill } from "react-icons/bs";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { Testimonials } from "../../../constants/testemonials.constant";

type Props = {};

const SiteTestemonialsComponent = (props: Props) => {
  const { t } = useTranslation();

  return (
    <section id="testemonials" className="bg-thirdColor">
      <Container>
        <Row className="p-lg-5 px-md-1 py-md-5 p-lg-5 py-4 px-4">
          <Col className="p-lg-5">
            <Row className="p-lg-5">
              <Swiper modules={[Autoplay]} autoplay={true}>
                {Testimonials.map((i, el) => {
                  return (
                    <SwiperSlide key={el}>
                      <Col>
                        <Row>
                          <Col className="d-flex align-items-center gap-2">
                            <div className="d-flex align-items-center gap-2">
                              <BsStarFill className="color-nineteenColor" />
                              <BsStarFill className="color-nineteenColor" />
                              <BsStarFill className="color-nineteenColor" />
                              <BsStarFill className="color-nineteenColor" />
                              <BsStarFill className="color-nineteenColor" />
                            </div>
                            <span className="fs-3 color-eighteenColor">
                              {i.star}.0
                            </span>
                          </Col>
                        </Row>
                        <Row className="mt-3">
                          <Col>
                            <p className="fs-3 color-eighteenColor">
                              “ {t(i.description)} ”
                            </p>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="d-flex gap-2 align-items-center">
                            <div>
                              <img
                                loading="lazy"
                                crossOrigin="anonymous"
                                src={i.image}
                                className="tw-w-10 tw-rounded-full"
                              />
                            </div>
                            <div className="d-flex flex-column">
                              <span className="font-sofiaSans color-sevenColor fw-bolder fs-5">
                                {i.fullName}
                              </span>
                              <span className="font-sofiaSans color-fourteenColor fs-6">
                                {t(i.job)}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SiteTestemonialsComponent;
